import React from 'react';
import { CheckCircle2 } from 'lucide-react';

interface StageIndicatorProps {
  currentStage: number;
}

const STAGES = [
  { id: 1, label: 'Write' },
  { id: 2, label: 'Review' },
  { id: 3, label: 'Article' },
  { id: 4, label: 'Social' },
];

const StageIndicator: React.FC<StageIndicatorProps> = ({ currentStage }) => {
  return (
    <div className="flex items-center space-x-1 bg-slate-100/50 dark:bg-slate-800/50 p-1 rounded-lg border border-slate-200/50 dark:border-slate-700/50">
      {STAGES.map((stage, idx) => {
        const isCompleted = currentStage > stage.id;
        const isCurrent = currentStage === stage.id;
        
        return (
          <div key={stage.id} className="flex items-center">
            {idx > 0 && <div className={`h-3 w-px mx-2 ${isCompleted ? 'bg-blue-500 dark:bg-blue-400' : 'bg-slate-300 dark:bg-slate-600'}`} />}
            <div className={`flex items-center space-x-1.5 px-2 py-0.5 rounded ${isCurrent ? 'bg-white dark:bg-slate-700 shadow-sm border border-slate-200 dark:border-slate-600' : ''}`}>
              {isCompleted ? (
                <CheckCircle2 className="h-3.5 w-3.5 text-blue-600 dark:text-blue-400" />
              ) : (
                <div className={`h-3.5 w-3.5 rounded-full border flex items-center justify-center text-[9px] font-bold transition-colors ${
                  isCurrent 
                    ? 'border-blue-600 text-blue-600 dark:border-blue-400 dark:text-blue-400' 
                    : 'border-slate-400 text-slate-500 dark:border-slate-500 dark:text-slate-400'
                }`}>
                  {stage.id}
                </div>
              )}
              <span className={`text-xs ${
                isCurrent 
                  ? 'font-semibold text-slate-800 dark:text-slate-100' 
                  : 'text-slate-500 dark:text-slate-400'
              }`}>{stage.label}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StageIndicator;